import JsEncrypt from 'jsencrypt'

export function rsa(source) {
  let jsEncrypt = new JsEncrypt.JSEncrypt()
  jsEncrypt.setPublicKey(window.config.PUBLICKEY)
  let rsaPassWord = jsEncrypt.encrypt(source)
  return rsaPassWord
}
